<div class="content-box">
  <ng-container *ngIf="renderCarouselData().length > 0">
    <div #carousel class="customize-carousel" (scroll)="onScroll($event)" [style.grid-auto-columns]="curClass.grid()">
      <ng-container *ngFor="let item of renderCarouselData()">
        <div class="carousel-item-container">
          <div class="carousel-item" [class.disabled]="!item">
            <a [href]="item?.customizedHref || ''" (click)="clickItem(item); $event.preventDefault()">
              <div class="carousel-img">
                <app-lazy-image [alt]="alt" [lazy]="item?.img || ''" [thumbWidth]="500" [radius]="8"></app-lazy-image>
              </div>
            </a>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- 點點點控制項 -->
    <div class="carousel-dots" *ngIf="totalPages > 1">
      <span
        *ngFor="let item of [].constructor(totalPages); index as index"
        class="dot"
        [class.active]="currentIndex === index"
        (click)="scrollToIndex(index)"
      ></span>
    </div>
    <div class="carousel-arrow-left" *ngIf="arrowLeft && !isH5" [class.show]="active" (click)="clickArrow(-1)">
      <i class="fi-cheveron-left"></i>
    </div>
    <div class="carousel-arrow-right" *ngIf="arrowRight && !isH5" [class.show]="active" (click)="clickArrow(1)">
      <i class="fi-cheveron-right"></i>
    </div>
  </ng-container>
</div>
